
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 41.934h28.238V3H8v38.934zM37.238 1a1 1 0 011 1v40.934a1 1 0 01-1 1H7a1 1 0 01-1-1V2a1 1 0 011-1h30.238zM11.055 12.854h6.365V6.488h-6.365v6.366zm-1 2a1 1 0 01-1-1V5.488a1 1 0 011-1h8.366a1 1 0 011 1v8.366a1 1 0 01-1 1h-8.366zm12.064-8.366a1 1 0 110-2h12.359a1 1 0 110 2h-12.36zm0 4.188a1 1 0 110-2h12.359a1 1 0 110 2h-12.36zm-12.064 8.378a1 1 0 110-2h24.423a1 1 0 110 2H10.055zm0 4.188a1 1 0 110-2h24.423a1 1 0 110 2H10.055zm0 4.19a1 1 0 110-2h24.423a1 1 0 110 2H10.055zM22.12 14.865a1 1 0 110-2h12.359a1 1 0 110 2h-12.36zm4.994 23.132h6.365v-6.365h-6.365v6.365zm7.365-8.365a1 1 0 011 1v8.365a1 1 0 01-1 1h-8.365a1 1 0 01-1-1v-8.365a1 1 0 011-1h8.365zM10.055 31.62a1 1 0 110-2h12.36a1 1 0 110 2h-12.36zm0 4.189a1 1 0 110-2h12.36a1 1 0 110 2h-12.36zm0 4.188a1 1 0 110-2h12.36a1 1 0 110 2h-12.36z"}})])
          )
        }
      }
    